// extracted by mini-css-extract-plugin
export var bubble = "_j-0";
export var container = "_j-f";
export var contrastBorder = "_j-g";
export var greyOut = "_j-2";
export var initialsColor0 = "_j-3";
export var initialsColor1 = "_j-4";
export var initialsColor10 = "_j-d";
export var initialsColor11 = "_j-e";
export var initialsColor2 = "_j-5";
export var initialsColor3 = "_j-6";
export var initialsColor4 = "_j-7";
export var initialsColor5 = "_j-8";
export var initialsColor6 = "_j-9";
export var initialsColor7 = "_j-a";
export var initialsColor8 = "_j-b";
export var initialsColor9 = "_j-c";
export var initialsWrapper = "_j-1";
export var large = "_j-l";
export var medium = "_j-k";
export var mediumSmall = "_j-j";
export var mediumSmallMedium = "_j-o";
export var micro = "_j-h";
export var small = "_j-i";
export var tiny = "_j-n";
export var xTiny = "_j-m";